import { ShieldCheck, MapPin, Globe } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import Reveal, { stagger, fadeUp } from "@/components/motion/Reveal";

const CELL_ICONS = [ShieldCheck, MapPin, Globe];

export default function About() {
  const { t } = useI18n();
  const a = t.about;
  return (
    <section id="about" data-testid="about-section" className="section-pad bg-white relative">
      <div className="absolute inset-0 noise-overlay pointer-events-none" aria-hidden />
      <div className="container-pro relative grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <Reveal>
            <div className="overline">{a.kicker}</div>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-medium tracking-tight">
              {a.title1}
              <span className="text-ink-muted">{a.title2}</span>
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-8 md:ps-10 md:border-s border-line">
          <Reveal variants={fadeUp}>
            <p className="text-lg leading-relaxed text-ink-secondary">
              {a.body1Pre}
              <strong className="text-ink-primary">{a.body1Bold}</strong>
              {a.body1Post}
            </p>
            <p className="mt-5 text-base leading-relaxed text-ink-secondary">{a.body2}</p>
          </Reveal>

          <Reveal variants={stagger(0.1, 0.12)} className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-px bg-line border border-line overflow-hidden rounded-lg">
            {a.cells.map((c, i) => (
              <FeatureCell key={i} icon={CELL_ICONS[i]} title={c.title} body={c.body} />
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
}

const FeatureCell = ({ icon: Icon, title, body }) => (
  <Reveal variants={fadeUp} className="group bg-white p-6 transition-colors hover:bg-surface-muted">
    <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-surface-muted text-brand-red border border-line transition-colors group-hover:bg-brand-red group-hover:text-white group-hover:border-brand-red">
      <Icon size={16} />
    </span>
    <div className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-brand-red">{title}</div>
    <p className="mt-3 text-sm text-ink-secondary leading-relaxed">{body}</p>
  </Reveal>
);
